import { render, staticRenderFns } from "./ProfileInfoCard.vue?vue&type=template&id=616e6c87&scoped=true"
import script from "./ProfileInfoCard.vue?vue&type=script&lang=js"
export * from "./ProfileInfoCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileInfoCard.vue?vue&type=style&index=0&id=616e6c87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e6c87",
  null
  
)

export default component.exports